module.exports = __webpack_public_path__ + "static/img/p6.236e3a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/certificate/patent/p6.jpg
// module id = ao7+
// module chunks = 0